import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    content: {
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.background.paper,
        outline: "none",
        padding: 10,
        borderRadius: 8,
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: 6,
        paddingLeft: 16,
        fontWeight: "bolder",
    },
    image: {
        maxHeight: "60vh",
    },
    featureButton: {
        margin: "0 10px",
        textTransform: "none",
        backgroundColor: theme.palette.info.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.info.dark,
        },
        "&:disabled": {
            backgroundColor: theme.palette.info.light,
        },
    },
}));
